// TODO: Remove no-shadow eslint disable after fixed: https://github.com/typescript-eslint/typescript-eslint/issues/2484
// eslint-disable-next-line no-shadow
export enum CountriesMutationTypes {
    SET_COUNTRIES = 'SET_COUNTRIES',
    SET_COUNTRY_CODE = 'SET_COUNTRY_CODE',
    SET_COMPANY_INFO = 'SET_COMPANY_INFO',
  }
  